import React from "react";
import { captureEvent } from "../../api/posthog";


const Joinvillage = () => {
  return (
    <div className="w-full px-6 md:px-16 pb-16 md:pb-20">
      <div className="max-w-[1280px] mx-auto">
        <div
          className="flex flex-col md:flex-row items-center justify-between gap-8 rounded-[24px] px-8 md:px-16 py-12 md:py-16"
          style={{
            background: "linear-gradient(135deg, #1167D0 0%, #3B82F6 100%)",
            boxShadow: "0px 16px 48px rgba(0, 82, 255, 0.25)",
          }}
        >
          <div className="flex flex-col gap-4 w-full md:w-7/12">
            <h2 className="text-[28px] md:text-[40px] text-white font-[800] font-avenir leading-tight text-center md:text-left">
              Join Your Village.
            </h2>
            <p className="text-[15px] md:text-[16px] text-blue-100 max-w-[440px] text-center md:text-left">
              Join thousands of parents building stronger tomorrows for their
              neurodivergent children.
            </p>
          </div>
          <div className="flex items-center justify-center">
            <button
              onClick={() => {
                captureEvent('signup_started', { source: 'landing_page_join_village' });
                const userAgent =
                  navigator.userAgent || navigator.vendor || window.opera;
                if (
                  /android/i.test(userAgent) ||
                  /Windows/i.test(userAgent)
                ) {
                  window.plausible("Play Store Click");
                  window.location.href =
                    "https://play.google.com/store/apps/details?id=com.social_spectrum.mobile";
                } else if (
                  /iPad|iPhone|iPod|ios/.test(userAgent) &&
                  !window.MSStream
                ) {
                  window.plausible("App Store Click");
                  window.location.href =
                    "https://apps.apple.com/us/app/social-spectrum/id6473112455";
                } else {
                  window.plausible("Play Store Click");
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.social_spectrum.mobile",
                    "_blank"
                  );
                }
              }}
              className="py-[14px] px-8 bg-white text-[#1167D0] text-[15px] font-[700] rounded-[32px] hover:bg-blue-50 transition-colors flex items-center gap-2 whitespace-nowrap"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 16L7 11H10V4H14V11H17L12 16Z" fill="#1167D0" />
                <path d="M5 20H19V18H5V20Z" fill="#1167D0" />
              </svg>
              Download Now →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Joinvillage;
